import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/style.scss";
import "./index.scss";
import App from "./App";
import { bootstrapAuthStorage } from "./utils/auth-bootstrap";
import { createBrowserHistory } from "history";
import { PrimeReactProvider } from "primereact/api";
const history = createBrowserHistory();

const onRedirectCallback = (appState: any) => {
  console.log("appState = ", appState);
  history.push(
    appState && appState.returnTo
      ? appState.returnTo
      : window.location.pathname,
  );
};

bootstrapAuthStorage();

const BUILD_ID = process.env.REACT_APP_BUILD_ID || "auth-fix-v3";
console.info("[PTT Admin] build", BUILD_ID, "auth-session-v3");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    {/* <Auth0Provider
            domain={`${process.env.REACT_APP_AUTH0_DOMAIN}`}
            clientId={`${process.env.REACT_APP_AUTH0_CLIENT_ID}`}
            onRedirectCallback={onRedirectCallback}
            authorizationParams={{
                redirect_uri: window.location.origin+process.env.REACT_APP_BASE_PATH
            }}
        > */}
    {/* <PrimeReactProvider> */}
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <App />
    </BrowserRouter>
    {/* </PrimeReactProvider> */}
    {/* </Auth0Provider> */}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
